import React from 'react'
import {
  Detail,
  Details,
  TitleGroup,
  SeeOffer,
  Price,
  Text,
  InfoArea,
} from '@/modern/components/Card'
import {
  Link,
  LinkWithGrow,
  AlignHeaderStamp,
  AlignFlagsStamp,
} from '../style'
import BrandOfferStamp from '@/modern/components/Stamps/BrandOffer'
import Stamp0km from '@/modern/components/Stamps/0kmStamp'

const SmartLeadVertical = ({
  model,
  make,
  version,
  price,
  year,
  travelledDistance,
  href = '#',
  stamps = {},
  dispatchDataLayer
}) => {
  const linkProps = { rel: 'nofollow', target: '_blank', href }

  return (
    <InfoArea>
      <LinkWithGrow {...linkProps} onClick={()=> dispatchDataLayer()}>
        <AlignHeaderStamp>
          <BrandOfferStamp brand={make} />
        </AlignHeaderStamp>

        <AlignFlagsStamp>
          <Stamp0km stamps={stamps} />
        </AlignFlagsStamp>

        <TitleGroup
          needsRightSpace={true}
          title={`${make} ${model}`}
          subtitle={version}
        />
      </LinkWithGrow>

      <Link {...linkProps} onClick={()=> dispatchDataLayer()}>
        <Price value={price} />
        <Details>
          <Detail>
            <Text value={year} />
          </Detail>
          <Detail>
            <Text value={travelledDistance} />
          </Detail>
        </Details>
        <SeeOffer link={linkProps.href} />
      </Link>

      <Details minHeight="36px"></Details>
    </InfoArea>
  )
}

export default SmartLeadVertical
